import { apiFetch, apiFetchResponse } from '../../lib/apiFetch';
import type { DocDirection, PartnerDocsStatus } from './partnerDocRequirements';

/** Server-computed partner-document status for a case (the one source of truth). */
export const fetchPartnerDocsStatus = (
  funeralId: string | number
): Promise<PartnerDocsStatus> =>
  apiFetch(`partner-documents/funeral/${funeralId}`);

/** Mark as sent / received by hand (Q2). */
export const markPartnerDoc = (
  funeralId: string | number,
  body: {
    partnerId: string;
    documentType: string;
    direction: DocDirection;
    method: 'manual';
    actorName?: string;
  }
): Promise<PartnerDocsStatus> =>
  apiFetch(`partner-documents/funeral/${funeralId}/mark`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const unmarkPartnerDoc = async (
  funeralId: string | number,
  rowId: number
): Promise<PartnerDocsStatus> => {
  const res = await apiFetchResponse(
    `partner-documents/funeral/${funeralId}/rows/${rowId}`,
    {
      method: 'DELETE',
    }
  );
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
};

/** Tell open partner-docs views on the page to reload (after a send, mark or upload). */
export const PARTNER_DOCS_CHANGED = 'partner-docs-changed';
export const announcePartnerDocsChanged = (funeralId: string | number) =>
  window.dispatchEvent(
    new CustomEvent(PARTNER_DOCS_CHANGED, {
      detail: { funeralId: String(funeralId) },
    })
  );
